export default __webpack_public_path__ + "static/media/work-min.79f997ac.jpg";